export const employeereportDetails = [
  {
    key:"1",
    EmpID: "Emp-001",
    Image: "user-32.jpg",
    Name: "Anthony Lewis",
    Role: "Finance",
    Email: "anthony@example.com",
    Department: "Finance",
    Phone: "(123) 4567 890",
    JoiningDate: "12/09/2024",
    Status: "Active",
  },
  {
    key:"2",
    EmpID: "Emp-002",
    Image: "user-09.jpg",
    Name: "Brian Villalobos",
    Role: "Developer",
    Email: "brian@example.com",
    Department: "Application Development",
    Phone: "(179) 7382 829",
    JoiningDate: "24/10/2024",
    Status: "Active",
  },
  {
    key:"3",
    EmpID: "Emp-003",
    Image: "user-01.jpg",
    Name: "Harvey Smith",
    Role: "Developer",
    Email: "harvey@example.com",
    Department: "IT Management",
    Phone: "(184) 2719 738",
    JoiningDate: "18/02/2024",
    Status: "Active",
  },
  {
    key:"4",
    EmpID: "Emp-004",
    Image: "user-33.jpg",
    Name: "Stephan Peralt",
    Role: "Executive Officer",
    Email: "peral@example.com",
    Department: "Web Development",
    Phone: "(193) 7839 748",
    JoiningDate: "17/10/2024",
    Status: "Active",
  },
  {
    key:"5",
    EmpID: "Emp-005",
    Image: "user-33.jpg",
    Name: "Doglas Martini",
    Role: "Manager",
    Email: "martniwr@example.com",
    Department: "Sales",
    Phone: "(183) 9302 890",
    JoiningDate: "20/07/2024",
    Status: "Active",
  },
  {
    key:"6",
    EmpID: "Emp-006",
    Image: "user-02.jpg",
    Name: "Linda Ray",
    Role: "Finance",
    Email: "ray456@example.com",
    Department: "UI / UX",
    Phone: "(120) 3728 039",
    JoiningDate: "10/04/2024",
    Status: "Active",
  },
  {
    key:"7",
    EmpID: "Emp-007",
    Image: "user-35.jpg",
    Name: "Elliot Murray",
    Role: "Finance",
    Email: "murray@example.com",
    Department: "Account Management",
    Phone: "(102) 8480 832",
    JoiningDate: "29/08/2024",
    Status: "Active",
  },
  {
    key:"8",
    EmpID: "Emp-008",
    Image: "user-36.jpg",
    Name: "Rebecca Smtih",
    Role: "Executive",
    Email: "smtih@example.com",
    Department: "Marketing",
    Phone: "(162) 8920 713",
    JoiningDate: "22/02/2024",
    Status: "Inactive",
  },
  {
    key:"9",
    EmpID: "Emp-009",
    Image: "user-37.jpg",
    Name: "Connie Waters",
    Role: "Developer",
    Email: "connie@example.com",
    Department: "Administration",
    Phone: "(189) 0920 723",
    JoiningDate: "03/11/2024",
    Status: "Active",
  },
  {
    key:"10",
    EmpID: "Emp-010",
    Image: "user-38.jpg",
    Name: "Lori Broaddus",
    Role: "Developer",
    Email: "broaddus@example.com",
    Department: "Business Development",
    Phone: "(168) 8392 823",
    JoiningDate: "17/12/2024",
    Status: "Active",
  },
];
